import React from "react";
import { X, Eye, EyeOff } from "lucide-react";

const ResetPassword = (
    {
        closeAllModals,
        handleResetPassword,
        newPassword,
        setNewPassword,
        showNewPassword,
        setShowNewPassword,
        confirmNewPassword,
        setConfirmNewPassword,
        showConfirmNewPassword,
        setShowConfirmNewPassword,
        resetPasswordLoading
    }
) => {
    return (
        <>
            <div className="modal-overlay">
                <div className="modal-container">
                    <div className="modal-header">
                        <h3>Reset Password</h3>
                        <button className="modal-close" onClick={closeAllModals}>
                            <X size={20} />
                        </button>
                    </div>
                    <div className="modal-body">
                        <p>Create a new password for your account</p>
                        <form onSubmit={handleResetPassword}>
                            <div className="form-group password-group">
                                <input
                                    type={showNewPassword ? "text" : "password"}
                                    placeholder="New Password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    required
                                />
                                <button
                                    type="button"
                                    className="password-toggle"
                                    onClick={() => setShowNewPassword(!showNewPassword)}
                                >
                                    {showNewPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                </button>
                            </div>
                            <div className="form-group password-group">
                                <input
                                    type={showConfirmNewPassword ? "text" : "password"}
                                    placeholder="Confirm New Password"
                                    value={confirmNewPassword}
                                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                                    required
                                />
                                <button
                                    type="button"
                                    className="password-toggle"
                                    onClick={() => setShowConfirmNewPassword(!showConfirmNewPassword)}
                                >
                                    {showConfirmNewPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                </button>
                            </div>
                            <div className="password-advice">
                                <p>Password should be at least 8 characters with a mix of letters, numbers, and symbols</p>
                            </div>
                            <button type="submit" className="submit-button" disabled={resetPasswordLoading}>
                                {resetPasswordLoading ? (
                                    <span className="loading-spinner">
                                        <span className="spinner"></span>
                                        Resetting...
                                    </span>
                                ) : (
                                    "Reset Password"
                                )}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}
export default ResetPassword